// extracted by mini-css-extract-plugin
module.exports = {"bg":"App_bg__3orU0","body":"App_body__1_BlC"};